/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {
  ContactDtoModel,
  CrmContactListMetadata,
  CustomerContactDtoModel,
  CustomerContactListVO
} from '@well/domain';
import {Observable} from 'rxjs';
import { AbstractResourceService, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerContactsResourceService extends AbstractResourceService<CustomerContactListVO,
  CustomerContactDtoModel,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('customerContactsUrl'),
      CustomerContactListVO,
      CustomerContactDtoModel
    );
  }

  getCustomerContactTemplate(customerUuid: string, path = '', query = ''): Observable<JsonApiResource<CustomerContactDtoModel, any>> {
    return this.httpClient?.get(`${this.url}/new/template/${customerUuid}${path}?${query}`)
      .pipe(this.getDtoMapper());
  }

  findContactForCustomer(customerUuid: string, query?: any, additionalParams?: any): Observable<JsonApiResource<CustomerContactListVO[], CrmContactListMetadata>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []
    ).toString();
    return this.httpClient?.get<JsonApiResource<CustomerContactListVO[], any>>(`${this.url}/${customerUuid}${queryString}`).pipe(
      map((jsonApiResource) => {
        jsonApiResource.data = jsonApiResource.data.map(item =>
          AbstractResourceService.resourceMapper(this.vType, item)
        );
        jsonApiResource.meta = AbstractResourceService.resourceMapper(
          CrmContactListMetadata,
          jsonApiResource.meta
        );
        return jsonApiResource;
      })
    );
  }

  saveContactForCustomer(customerUuid: string, resource: CustomerContactDtoModel) {
    return this.httpClient?.post(`${this.url}/${customerUuid}`, resource, {headers: this.headers})
      .pipe(this.getDtoMapper());
  }

  updateContactForCustomer(customerUuid: string, resource: CustomerContactDtoModel) {
    return this.httpClient?.put(`${this.url}/${customerUuid}`, resource, {headers: this.headers})
      .pipe(this.getDtoMapper());
  }

  findContactById(customerUuid: string, id: string): Observable<JsonApiResource<CustomerContactDtoModel, null>> {
    return this.httpClient?.get(`${this.url}/${customerUuid}/${id}`).pipe(this.getDtoMapper());
  }

  findContactDTOSuggestions(customerUuid: string,
                            query?: any,
                            additionalParams?: any): Observable<JsonApiResource<ContactDtoModel[], any>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []
    ).toString();
    return <Observable<JsonApiResource<ContactDtoModel[], any>>> this.httpClient?.get<JsonApiResource<ContactDtoModel[], any>>(`${this.url}/businessProfile/suggestions/${customerUuid}${queryString}`).pipe(
      map((jsonApiResource) => {
        jsonApiResource.data = jsonApiResource.data.map(item =>
          AbstractResourceService.resourceMapper(ContactDtoModel, item)
        );
        jsonApiResource.meta = AbstractResourceService.resourceMapper(
          this.mvType,
          jsonApiResource.meta
        );
        return jsonApiResource;
      })
    );
  }

}

